const faq = {
  getFAQs: async function() {
    return await this.$store.getters
      .fetcher({
        query: `{ faqs {
          FAQ_Id
          Question
          Answer
        }
      }`
      })
      .then(r => {
        return r.data.faqs;
      });
  },

  createFAQ: async function(faqToCreate) {
    var query = `
    mutation($question: String!, $answer: String!) {
      CreateFAQ(question: $question, answer: $answer) {
        FAQ_Id
      }
    }`;
    var variables = {
      question: faqToCreate.Question.trim(),
      answer: faqToCreate.Answer.trim()
    };

    return await this.$store.getters.fetcher({ query, variables }).then(r => {
      faqToCreate.FAQ_Id = r.data.CreateFAQ.FAQ_Id;
      return faqToCreate;
    });
  },
  updateFAQ: async function(faqToUpdate) {
    var query = `
    mutation($faqId: Int!, $question: String!, $answer: String!) {
      UpdateFAQ(faqId: $faqId, question: $question, answer: $answer) {
        FAQ_Id
      }
    }`;
    var variables = {
      faqId: parseInt(faqToUpdate.FAQ_Id),
      question: faqToUpdate.Question.trim(),
      answer: faqToUpdate.Answer.trim()
    };

    return await this.$store.getters.fetcher({ query, variables }).then(() => {
      return faqToUpdate;
    });
  },
  deleteFAQ: async function(faqToDelete) {
    var query = `
    mutation($faqId: Int!) {
      DeleteFAQ(faqId: $faqId) 
    }`;
    var variables = {
      faqId: parseInt(faqToDelete.FAQ_Id)
    };

    return await this.$store.getters.fetcher({ query, variables }).then(() => {
      return faqToDelete;
    });
  }
};

export { faq };
